<template>
  <div
    id="bottom-progress-bar"
    class="bottom-slide-progress-bar"
  >
    <div
      class="slide-progress-bar"
      :style="{
        width: percentProgress
      }"
    />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import logger from '@/logger'

const logFn = logger.extend('SlideProgressBar')

export default {
  computed: {
    ...mapGetters({
      activeSlide: 'activeActivity',
      slides: 'slideProgress/visibleSlides',
    }),
    ...mapGetters('featureToggles', [
      'canUseSkipSlide',
    ]),
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    percentProgress() {
      const index = this.slides.findIndex((item) => {
        return item.id == this.activeSlide.id
      })
      if (index !== -1 && this.slides.length) {
        return `${((index + 1) * 100) / this.slides.length}%`
      }
      return `${0}%`
    },
  },
  watch: {
    'slide.id': {
      handler() {
        this.getDataProgress()
      },
      immediate: true,
    },
    'presentation.presenting': function handlePresentingChange(newValue) {
      if (newValue && this.canUseSkipSlide) {
        // in case of presenter start presenting again
        // fetch slide list to handle case of slides getting added/removed
        this.getSlideList()
        logFn('getting slide list on start presenting')
      }
    },
  },
  mounted() {
    this.getSlideList()
    if (this.canUseSkipSlide && this.presentation.id) {
      this.subscribeSlideAttributeChanges({ presentationId: this.presentation.id })
    }
  },
  destroyed() {
    if (this.canUseSkipSlide && this.presentation.id) {
      this.unsubscribeSlideAttributeChanges({ presentationId: this.presentation.id })
    }
  },
  methods: {
    ...mapActions([
      'getSlidesAction',
      'setSlideIndexAction',
      'getSlidesWithAttributesAction',
      'unsubscribeSlideAttributeChanges',
      'subscribeSlideAttributeChanges',
    ]),
    getDataProgress() {
      if (!this.activeSlide.id && !this.slides.length) return

      const index = this.slides.findIndex((item) => {
        return item.id == this.activeSlide.id
      })

      if (index != -1) {
        this.setSlideIndexAction({
          index,
        })
      }
    },
    async getSlideList() {
      try {
        if (this.canUseSkipSlide) {
          await this.getSlidesWithAttributesAction()
        } else {
          await this.getSlidesAction()
        }
        this.getDataProgress()
      } catch (error) {
        if (Sentry && error.status) {
          Sentry.captureException(JSON.stringify(error))
        }
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.bottom-slide-progress-bar {
  height: 4px;
  width: 100%;
  background-color: #D3D7E1;

  .slide-progress-bar {
    background-color: #313131;
    height: 100%;
    transition: width 0.5s;
  }
}
</style>
